module.exports = __webpack_public_path__ + "assets/img/bg-cdb43aff.jpg";